import qs from 'qs';
import http, { defaultConfig, getUniversityUrl } from './http';
import { activity } from './mappers';
import { TFunction } from 'i18next';


export type FetchLogTypeResponse = APIResponse<Record<string, string>[]>;

export interface FetchActivityLogOptions {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  actionTypes?: string[];
  findVariantById?: any;
  t: TFunction;
}

export const fetchActivityLogs = async ({
  page = 1,
  limit = 200,
  findVariantById = undefined,
  fromDate,
  toDate,
  actionTypes,
  t
}: FetchActivityLogOptions) => {
  const baseURL = getUniversityUrl();
  const queries = qs.stringify(
    { page, size: limit, fromDate, toDate, actionTypes },
    { indices: false });
  const url = `/rest/users/activity-logs?${queries}`;
  const res = (await (http.get<APIResponse<ActivityReportEntity[]>>(url, {
    ...defaultConfig(baseURL),
    timeout: 120000
  })));

  return {
    total: res.data.payload.totalElements,
    items: activity.mapItems(res.data.payload.content ?? [], findVariantById, t),
  };
};

export async function fetchLogTypes() {
  const baseURL = getUniversityUrl();
  const url = `/rest/activity-logs/types`;
  const res = (await (http.get<APIResponse<any[]>>(url, {
    ...defaultConfig(baseURL),
    timeout: 120000
  })));

  return res.data
};
